$(function () {
    var data = {
        username: '',
        firstName: '',
        lastName: '',
        isExt: false,
        socialProfiles: {}
    };
    var cookieParam = 'y-real_social_u';
    var isAndroid = (navigator.userAgent.match(/Android/i) && navigator.userAgent.match(/Mobile/i));
    var isIos = navigator.userAgent.match(/iPhone/i);

    function getCookie(name) {
        var start = document.cookie.indexOf(name + "=");
        var len = start + name.length + 1;
        if (( !start ) && ( name !== document.cookie.substring(0, name.length) )) {
            return null;
        }
        if (start === -1) return null;
        var end = document.cookie.indexOf(';', len);
        if (end === -1) end = document.cookie.length;
        return document.cookie.substring(len, end);
    }

    function setCookie(name, value) {
        var expires = new Date(2050, 1, 1);
        document.cookie = name + "=" + value + "; expires=" + expires.toGMTString() + "; domain=.ykt.ru; path=/";
    }

    function loadScriptByUrl(url, callback) {
        var js = document.createElement('script');
        js.type = 'text/javascript';
        js.async = true;
        if (js.readyState) {
            js.onreadystatechange = function () {
                if (js.readyState === 'loaded' || js.readyState === 'complete') {
                    callback.call(this);
                }
            };
        } else {
            js.onload = function () {
                callback.call(this);
            };
        }
        js.src = url;
        var body = document.querySelector('body');
        body.appendChild(js);
    }

    function getJSON(url, data, callback) {
        if (typeof callback === 'undefined' && typeof data === 'function') {
            callback = data;
        }
        if (jQuery.fn.jquery === '1.8.3' || jQuery.fn.jquery === '1.7.2') {
            $.ajax({
                url: url,
                type: 'GET',
                dataType: 'jsonp',
                jsonp: 'jsonp',
                xhrFields: {
                    withCredentials: true
                },
                success: callback,
                error: function () {
                    alert("Извините, что-то пошло не так.");
                }
            });
        } else {
            $.ajax({
                url: url,
                method: 'GET',
                dataType: 'jsonp',
                jsonp: 'jsonp',
                xhrFields: {
                    withCredentials: true
                },
                success: callback,
                error: function () {
                    alert("Извините, что-то пошло не так.");
                }
            });
        }
    }

    var showModal = getCookie(cookieParam);

    var mainContainer = document.getElementById('y-sname');
    if (mainContainer !== null && typeof jQuery !== 'undefined') {

        getJSON('//id.ykt.ru/api/getCurrentUserInfo', function (response) {
            if (!response.isAnonymous) {
                data.isExt = response.isExt;
                data.username = response.nick;
                data.socialProfiles = response.social_profiles;

                function showFio() {
                    if ((data.firstName !== '' && data.firstName !== null) || (data.lastName !== '' && data.lastName !== null)) {
                        if (typeof jQuery !== 'undefined') {
                            if (jQuery.fn.jquery === '1.8.3' || jQuery.fn.jquery === '1.7.2') {
                                $.ajax({
                                    url: '//id.ykt.ru/api/setData',
                                    type: 'POST',
                                    xhrFields: {
                                        withCredentials: true
                                    },
                                    data: {
                                        lastname: data.lastName,
                                        firstname: data.firstName,
                                        site: document.location.hostname,
                                        jsonp: 'jsonp'
                                    },
                                    success: function (response) {
                                        if (response.result === 'ok') {
                                            setCookie(cookieParam, "closed");
                                            showSuccess();
                                        } else {
                                            alert("Извините, что-то пошло не так.");
                                        }
                                    },
                                    error: function () {
                                        setCookie(cookieParam, "closed");
                                        showSuccess();
                                        // alert("Извините, что-то пошло не так.");
                                    }
                                });
                            } else {
                                $.ajax({
                                    url: '//id.ykt.ru/api/setData',
                                    method: 'POST',
                                    xhrFields: {
                                        withCredentials: true
                                    },
                                    data: {
                                        lastname: data.lastName,
                                        firstname: data.firstName,
                                        site: document.location.hostname,
                                        jsonp: 'jsonp'
                                    },
                                    success: function (response) {
                                        if (response.result === 'ok') {
                                            setCookie(cookieParam, "closed");
                                            showSuccess();
                                        } else {
                                            alert("Извините, что-то пошло не так.");
                                        }
                                    },
                                    error: function () {
                                        setCookie(cookieParam, "closed");
                                        showSuccess();
                                        // alert("Извините, что-то пошло не так.");
                                    }
                                });
                            }
                        }
                    }
                }

                if ((showModal === 'show' || showModal === 'hide') && document.location.hostname !== 'pechka.ykt.ru') {
                    mainContainer.style.display = 'none';

                    var hasSocialAccount = false;

                    var fragmentContainer = document.createDocumentFragment();
                    var modalContainer = document.createElement('div');
                    modalContainer.className = 'remodal y-sname';
                    modalContainer.setAttribute('data-remodal-id', 'modal');

                    var closeBtn = document.createElement('button');
                    closeBtn.className = 'remodal-close';
                    closeBtn.setAttribute('data-remodal-action', 'close');
                    modalContainer.appendChild(closeBtn);

                    var logo = document.createElement('div');
                    logo.className = 'y-sname_logo';
                    modalContainer.appendChild(logo);

                    var header = document.createElement('div');
                    header.className = 'y-sname_header';
                    header.innerHTML = 'Теперь вы можете показать рядом с ником свое реальное имя из соцсети:';
                    modalContainer.appendChild(header);

                    var body = document.createElement('div');
                    body.className = 'y-sname_body';

                    var username = document.createElement('span');
                    username.className = 'y-sname_username';
                    username.innerHTML = data.username;
                    body.appendChild(username);

                    var socialIcon = document.createElement('span');
                    socialIcon.className = 'y-sname_social';
                    body.appendChild(socialIcon);

                    var fio = document.createElement('span');
                    fio.className = 'y-sname_fio';

                    for (var socialItem in data.socialProfiles) {
                        if (data.socialProfiles.hasOwnProperty(socialItem)) {
                            if (data.socialProfiles[socialItem] > 0) {
                                var socialId = data.socialProfiles[socialItem];
                                socialIcon.className += ' ' + socialItem;
                                if (socialItem === 'vk') {
                                    hasSocialAccount = true;
                                    loadScriptByUrl('https://vk.com/js/api/openapi.js?150', function (socialId) {
                                        VK.init({
                                            apiId: 1877276
                                        });
                                        VK.Api.call("users.get", {user_ids: socialId}, function (vkData) {
                                            data.firstName = vkData.response[0].first_name;
                                            data.lastName = vkData.response[0].last_name;
                                            fio.innerHTML = data.firstName + " " + data.lastName;
                                        });
                                    }.bind(this, socialId));
                                }
                                if (socialItem === 'fb') {
                                    hasSocialAccount = true;
                                    loadScriptByUrl('https://connect.facebook.net/ru_RU/sdk.js', function (socialId) {
                                        FB.init({
                                            appId: 240223402676491,
                                            autoLogAppEvents: true,
                                            xfbml: true,
                                            version: 'v2.11'
                                        });
                                        FB.AppEvents.logPageView();
                                        FB.getLoginStatus(function (loginStatusResponse) {
                                            if (loginStatusResponse.status === 'connected') {
                                                var accessToken = loginStatusResponse.authResponse.accessToken;
                                                console.log(accessToken);
                                                FB.api('/me', {access_token: accessToken, fields: 'first_name,last_name'}, function(response) {
                                                    if (response && !response.error) {
                                                        data.firstName = response.first_name;
                                                        data.lastName = response.last_name;
                                                        fio.innerHTML = data.firstName + " " + data.lastName;
                                                    }
                                                });
                                            }
                                        });
                                    }.bind(this, socialId));
                                }
                                break;
                            }
                        }
                    }
                    body.appendChild(fio);
                    modalContainer.appendChild(body);

                    var footer = document.createElement('div');
                    footer.className = 'y-sname_footer';

                    var saveBtn = document.createElement('button');
                    saveBtn.className = 'yui-btn yui-btn--green yui-btn--block y-sname_btn';
                    saveBtn.innerHTML = 'Показать имя';
                    saveBtn.addEventListener('click', showFio);
                    footer.appendChild(saveBtn);
                    modalContainer.appendChild(footer);

                    fragmentContainer.appendChild(modalContainer);
                    mainContainer.appendChild(fragmentContainer);

                    /* напоминалка */
                    var popupContainer = document.createElement('div');
                    popupContainer.className = 'y-popup';
                    popupContainer.style.display = 'none';

                    var popupWoman = document.createElement('div');
                    popupWoman.className = 'y-popup_woman';
                    popupContainer.appendChild(popupWoman);

                    var popupBody = document.createElement('div');
                    popupBody.className = 'y-popup_body';

                    var popupText = document.createElement('div');
                    popupText.className = 'y-popup_text';
                    popupText.innerHTML = 'Отображайте реальное имя из соцсети';
                    popupBody.appendChild(popupText);

                    var popupOpenBtn = document.createElement('button');
                    popupOpenBtn.className = 'y-popup_open';
                    popupOpenBtn.innerHTML = 'Показать';
                    popupBody.appendChild(popupOpenBtn);

                    var popupCloseBtn = document.createElement('button');
                    popupCloseBtn.className = 'y-popup_close';
                    popupCloseBtn.innerHTML = 'Закрыть';
                    popupBody.appendChild(popupCloseBtn);

                    popupContainer.appendChild(popupBody);

                    document.body.appendChild(popupContainer);

                    /* готово! */
                    var successContainer = document.createElement('div');
                    successContainer.className = 'y-popup success';
                    successContainer.style.display = 'none';

                    var successWoman = document.createElement('div');
                    successWoman.className = 'y-popup_woman';
                    successContainer.appendChild(successWoman);

                    var successBody = document.createElement('div');
                    successBody.className = 'y-popup_body';

                    var successText = document.createElement('div');
                    successText.className = 'y-popup_text';
                    successText.innerHTML = 'Готово!';
                    successBody.appendChild(successText);

                    successContainer.appendChild(successBody);

                    document.body.appendChild(successContainer);

                    var $popupContainer = $(popupContainer);
                    var $successContainer = $(successContainer);
                    var $mainContainer = $(mainContainer);

                    var remodal = $('[data-remodal-id="modal"]').remodal({
                        closeOnOutsideClick: false
                        , hashTracking: false
                    });

                    $(popupCloseBtn).on('click', function () {
                        setCookie(cookieParam, "closed");
                        hidePopup();
                    });

                    $(popupOpenBtn).on('click', function () {
                        hidePopup();
                        showFio();
                    });

                    function hidePopup() {
                        $popupContainer.animate({opacity: 0, bottom: '-120px'}, 200, function () {
                            $(this).hide().css({opacity: 0})
                        });
                    }

                    function showPopup() {
                        $popupContainer.show().animate({opacity: 1, bottom: '10px'}, 200);
                    }

                    function hideSuccess() {
                        $successContainer.animate({opacity: 0, bottom: '-120px'}, 200, function () {
                            $(this).hide().css({opacity: 0})
                        });
                    }

                    function showSuccess() {
                        ga('send', 'event', 'modal_social', 'add_social');
                        $successContainer.show().animate({opacity: 1, bottom: '10px'}, 200);
                        remodal.close();
                        setTimeout(hideSuccess, 3000);
                    }

                    if (hasSocialAccount) {
                        $mainContainer.show();
                        if (getCookie(cookieParam) === 'hide') {
                            showPopup();
                        } else {
                            remodal.open();
                            ga('send', 'event', 'modal_social', 'view');
                        }
                    }

                    $(document).on('closed', '.y-sname', function (e) {
                        console.log(getCookie(cookieParam));
                        if (getCookie(cookieParam) !== 'closed') {
                            if (e.reason) {
                                setCookie(cookieParam, "closed");
                            } else {
                                if (!isAndroid && !isIos) {
                                    setCookie(cookieParam, "hide");
                                    showPopup();
                                } else {
                                    setCookie(cookieParam, "closed");
                                }
                            }
                        }
                    });
                }
            }
        });
    }
});